import { render, staticRenderFns } from "./KnowledgeSettings.vue?vue&type=template&id=55b70188&scoped=true&"
import script from "./KnowledgeSettings.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeSettings.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeSettings.vue?vue&type=style&index=0&id=55b70188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b70188",
  null
  
)

export default component.exports